
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.274 15.276c1.72-.922 3.422-1.831 5.148-2.757-.463-.215-.897-.415-1.33-.614l-.996-.454a.31.31 0 01-.17-.166c-.512-1.135-1.027-2.266-1.54-3.398-.015-.033-.025-.07-.048-.132.375.116.727.225 1.076.335l4.404 1.373c.845.262 1.69.531 2.538.787.118.036.144.093.144.209-.003 1.25-.003 2.498 0 3.75 0 .105-.03.162-.12.218-2.9 1.752-5.801 3.51-8.701 5.27-.13.079-.264.152-.392.238-.065.046-.11.033-.17-.01l-3.532-2.518a.176.176 0 01-.082-.166c.004-.223 0-.442 0-.664 0-3.37.004-6.745.004-10.116 0-.94 0-1.882-.007-2.82 0-.147.033-.163.163-.12 1.148.401 2.3.8 3.452 1.194.097.033.117.09.117.183 0 .68 0 1.36.003 2.04l.04 8.176v.162z","fill":"#0D8484"}})])
          )
        }
      }
    